import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { DeliveriesScreen } from '@/features/deliveries/DeliveriesScreen';
import { useTenant } from '@/lib/tenant';

function DeliveriesRoute() {
  const { slug } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <DeliveriesScreen slug={slug} />;
}

export const Route = createFileRoute('/tenants/$slug/deliveries')({
  component: DeliveriesRoute,
});
